import * as React from 'react';
import 'handsontable/dist/handsontable.full.min.css';
import { HyperFormula } from 'hyperformula';

import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react';
import {useEffect} from "react";

registerAllModules();


export interface HandsonTableProps {
    data: any;
    mergedCells?: any[]
}

export function HandsonTable({ data, mergedCells }: HandsonTableProps) {

    const [preparedData, setPreparedData] = React.useState([]);

    useEffect(() => {
        console.log('HandsonTable mounted with data:', data);
        var prepreparedData = data.map((row: any) => {
            return row.map((cell: any) => {
                if(cell.formula) {
                    return cell.formula;
                }
                return cell.value;
            });
        })
        setPreparedData(prepreparedData);

    }, [data]);

    //  create an external HyperFormula instance
    const hyperformulaInstance = HyperFormula.buildEmpty({
        // to use an external HyperFormula instance,
        // initialize it with the `'internal-use-in-handsontable'` license key
        licenseKey: 'internal-use-in-handsontable',
    });

    return <HotTable
        data={preparedData}
        rowHeaders={true}
        colHeaders={true}
        height="100%"
        autoWrapRow={true}
        autoWrapCol={true}
        manualColumnResize={true}
        manualRowResize={true}
        formulas={{
            engine: hyperformulaInstance,
            sheetName: 'Sheet1',
        }}
        mergeCells={mergedCells}
        licenseKey="non-commercial-and-evaluation" // for non-commercial use only
    />
}